import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  salaryConfigurations: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 1,
  },
  selectedSalaryConfiguration: null,
  approving: false,
};

const salaryConfigurationSlice = createSlice({
  name: "companySalaryConfiguration",
  initialState,
  reducers: {
    // Get Salary Configurations
    getSalaryConfigurationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSalaryConfigurationsSuccess: (state, action) => {
      state.loading = false;
      state.salaryConfigurations = action.payload.configurations || [];
      state.pagination = action.payload.pagination || initialState.pagination;
      state.error = null;
    },
    getSalaryConfigurationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Salary Configuration
    createSalaryConfigurationStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createSalaryConfigurationSuccess: (state, action) => {
      state.loading = false;
      state.salaryConfigurations.push(action.payload);
      state.error = null;
    },
    createSalaryConfigurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Salary Configuration
    updateSalaryConfigurationStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSalaryConfigurationSuccess: (state, action) => {
      state.loading = false;
      const index = state.salaryConfigurations.findIndex(
        (config) => config.id === action.payload.id,
      );
      if (index !== -1) {
        state.salaryConfigurations[index] = action.payload;
      }
      state.error = null;
    },
    updateSalaryConfigurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Approve Salary Configuration
    approveSalaryConfigurationStart: (state) => {
      state.approving = true;
      state.error = null;
    },
    approveSalaryConfigurationSuccess: (state, action) => {
      state.approving = false;
      const index = state.salaryConfigurations.findIndex(
        (config) => config.id === action.payload,
      );
      if (index !== -1) {
        state.salaryConfigurations[index].status = "active";
      }
      state.error = null;
    },
    approveSalaryConfigurationFailure: (state, action) => {
      state.approving = false;
      state.error = action.payload;
    },

    // Delete Salary Configuration
    deleteSalaryConfigurationStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteSalaryConfigurationSuccess: (state, action) => {
      state.loading = false;
      state.salaryConfigurations = state.salaryConfigurations.filter(
        (config) => config.id !== action.payload,
      );
      state.error = null;
    },
    deleteSalaryConfigurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Salary Configuration
    setSelectedSalaryConfiguration: (state, action) => {
      state.selectedSalaryConfiguration = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getSalaryConfigurationsStart,
  getSalaryConfigurationsSuccess,
  getSalaryConfigurationsFailure,
  createSalaryConfigurationStart,
  createSalaryConfigurationSuccess,
  createSalaryConfigurationFailure,
  updateSalaryConfigurationStart,
  updateSalaryConfigurationSuccess,
  updateSalaryConfigurationFailure,
  approveSalaryConfigurationStart,
  approveSalaryConfigurationSuccess,
  approveSalaryConfigurationFailure,
  deleteSalaryConfigurationStart,
  deleteSalaryConfigurationSuccess,
  deleteSalaryConfigurationFailure,
  setSelectedSalaryConfiguration,
  clearError,
} = salaryConfigurationSlice.actions;

export default salaryConfigurationSlice.reducer;
